import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e1226be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-flush pt-3 mb-5 mb-lg-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#technical-tracking-report-params",
  "aria-expanded": "true",
  "aria-controls": "technical-tracking-report-params"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Parametreler - Teknik Takip Raporu")
  ])
], -1))
const _hoisted_3 = {
  id: "technical-tracking-report-params",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body p-9" }
const _hoisted_5 = { class: "row mb-6" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createTextVNode("Sipariş Tarihi 1 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createTextVNode("Sip. Tarihi 2 "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createTextVNode("Sezon "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Sipariş Şekli", -1))
const _hoisted_14 = { class: "row mb-10" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createTextVNode("Müşteri "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createTextVNode("Üretici "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, [
  /*#__PURE__*/_createTextVNode("Departman "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Marka", -1))
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-md-4" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Mal Giriş Talebi", -1))
const _hoisted_26 = { class: "d-flex mt-2" }
const _hoisted_27 = { class: "form-check form-check-inline me-5" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ms-1",
  for: "materialRequestAll"
}, " Tümü ", -1))
const _hoisted_29 = { class: "form-check form-check-inline me-5" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ms-1",
  for: "materialRequestYes"
}, " Var ", -1))
const _hoisted_31 = { class: "form-check form-check-inline" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ms-1",
  for: "materialRequestNo"
}, " Yok ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, null, -1))
const _hoisted_34 = {
  key: 0,
  class: "card card-flush pt-3 mb-5 mb-lg-10"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Teknik Takip Raporu Sonuçları")
  ])
], -1))
const _hoisted_36 = { class: "card-body py-3" }
const _hoisted_37 = { class: "table-responsive w-100" }
const _hoisted_38 = { class: "datatable datatable-default datatable-bordered datatable-loaded w-100" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-print",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-file-excel",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_42 = [
  _hoisted_41
]

import { ref, computed } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import Calendar from "primevue/calendar";

// Bileşenler
import CustomerMultiSelect from "@/components/customers/CustomerMultiSelect.vue";
import SupplierMultiSelect from "@/components/suppliers/SupplierMultiSelect.vue";
import DepartmentMultiSelect from "@/components/departments/DepartmentMultiSelect.vue";
import SeasonMultiSelect from "@/components/seasons/SeasonMultiSelect.vue";
import BrandMultiSelect from "@/components/brands/BrandMultiSelect.vue";
import OrderTypeMultiSelect from "@/components/orderTypes/OrderTypeMultiSelect.vue";

// Store ve router
import { useRouter } from "vue-router";
import VueHtmlToPaper from "@/core/plugins/VueHtmlToPaper";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const router = useRouter();
const store = useStore();
const loading = ref(false);

// Filtre değişkenleri
const customers = ref();
const suppliers = ref();
const departmentIds = ref();
const seasonIds = ref();
const brandIds = ref([]);
const orderTypeIds = ref([]);
const orderDateOne = ref();
const orderDateTwo = ref();
const hasMaterialRequest = ref("all");

// Filtre işlevleri
const selectedCustomer = (args) => {
  customers.value = args.value;
};

const selectedSupplier = (args) => {
  suppliers.value = args.value;
};

const selectedDepartment = (args) => {
  departmentIds.value = args.value;
};

const selectedSeason = (args) => {
  if (args.value) {
    seasonIds.value = args.value;
  } else {
    seasonIds.value = [];
  }
};

const selectedBrand = (args) => {
  if (args.value && args.value.length > 0) {
    brandIds.value = args.value.map((item) => item.value);
  } else {
    brandIds.value = [];
  }
};

const selectedOrderType = (args) => {
  if (args.value && args.value.length > 0) {
    orderTypeIds.value = args.value.map((item) => item.value);
  } else {
    orderTypeIds.value = [];
  }
};

// Filtre temizleme işlevleri
const clearCustomer = () => {
  customers.value = null;
};

const clearSupplier = () => {
  suppliers.value = null;
};

const clearDepartment = () => {
  departmentIds.value = null;
};

const clearSeason = () => {
  seasonIds.value = null;
};

const clearBrand = () => {
  brandIds.value = [];
};

const clearOrderType = () => {
  orderTypeIds.value = [];
};

const clearFilters = () => {
  customers.value = null;
  suppliers.value = null;
  departmentIds.value = null;
  seasonIds.value = null;
  brandIds.value = [];
  orderTypeIds.value = [];
  orderDateOne.value = null;
  orderDateTwo.value = null;
  hasMaterialRequest.value = "all";
};

// Tablo filtreleri
const filters = ref({
  customerName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  articleNo: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  orderCode: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  supplierName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  departmentName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  seasonName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  brandName: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  otEntranceDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  otExitDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  fmCriticalEntranceDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  fmCriticalExitDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  nvRequestTradeCode: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  nvRequestDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  nvEntranceDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  nvExitDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  nvCriticalEntranceDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  nvCriticalExitDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  otApprovalDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  productionApprovalDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  hasMaterialRequest: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
  fileDeliveryDate: {
    operator: FilterOperator.AND,
    constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
  },
});

// Rapor verileri
const technicalTrackingReportList = computed(
  () => store.state.ReportModule.technicalTrackingReport?.value || []
);

// Veri olup olmadığını kontrol et
const hasData = computed(() => {
  return (
    technicalTrackingReportList.value &&
    technicalTrackingReportList.value.length > 0
  );
});

// Filtrelenmiş veriler
const filteredData = ref();
const filterData = (data) => {
  filteredData.value = data;
};

const filteredDataList = computed(() => filteredData.value || []);

// Arama işlevi
const send = () => {
  loading.value = true;
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

  const materialRequestFilter =
    hasMaterialRequest.value === "all"
      ? null
      : hasMaterialRequest.value === "true";

  const model = {
    orderDateOne: orderDateOne.value,
    orderDateTwo: orderDateTwo.value,
    customerIds: customers.value ? customers.value.map((f) => f.id) : [],
    supplierIds: suppliers.value ? suppliers.value.map((f) => f.id) : [],
    departmentIds: departmentIds.value
      ? departmentIds.value.map((f) => f.value)
      : [],
    seasonIds: seasonIds.value ? seasonIds.value.map((f) => f.value) : [],
    brandIds: brandIds.value || [],
    orderTypeIds: orderTypeIds.value || [],
    hasMaterialRequest: materialRequestFilter,
  };

  store
    .dispatch(Actions.TECHNICAL_TRACKING_REPORT_LIST, model)
    .then(() => {
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      loading.value = false;
    })
    .catch((error) => {
      console.error("Rapor yüklenirken hata oluştu:", error);
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
      loading.value = false;
    });
};

// Excel dışa aktarma
const exportExcel = () => {
  // Excel yükleniyor göstergesini aç
  loading.value = true;
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

  // Kullanılacak veri listesini belirle (filtrelenmiş veya tüm veriler)
  const dataList = filteredData.value || technicalTrackingReportList.value;

  // İşlem yapacak veri yoksa uyarı göster ve çık
  if (!dataList || dataList.length === 0) {
    store.commit("SET_WARNING", "Dışa aktarılacak veri bulunamadı!");
    loading.value = false;
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
    return;
  }

  import("xlsx").then((xlsx) => {
    try {
      // Sütun başlıkları - tablodaki sıraya göre
      const headers = {
        Sezon: "seasonName",
        Müşteri: "customerName",
        Marka: "brandName",
        Departman: "departmentName",
        Tedarikçi: "supplierName",
        "Model Kodu": "modelCode",
        Artikel: "articleNo",
        Yükleme: "shippingDate",
        Varış: "deliveryDate",
        "ÖT Geliş": "otEntranceDate",
        "ÖT Çıkış": "otExitDate",
        "FM Kritik Geliş": "fmCriticalEntranceDate",
        "FM Kritik Çıkış": "fmCriticalExitDate",
        "NV Kodu": "nvRequestTradeCode",
        "NV Talebi": "nvRequestDate",
        "NV Geliş": "nvEntranceDate",
        "NV Çıkış": "nvExitDate",
        "NV Kritik Geliş": "nvCriticalEntranceDate",
        "NV Kritik Çıkış": "nvCriticalExitDate",
        "ÖT Onayı": "otApprovalDate",
        "Üretim Onayı": "productionApprovalDate",
        "Kumaş Onayı": "fabricApprovalDate",
        "Mal Giriş Talebi": "hasMaterialRequest",
        "Dosya Teslim": "fileDeliveryDate",
      };

      // Excel verisi oluştur
      const excelData = dataList.map((item) => {
        const row = {};
        // Sütun başlıklarını kullanarak veriyi dönüştür
        Object.entries(headers).forEach(([headerText, fieldName]) => {
          if (fieldName === "nvRequestTradeCode" && item[fieldName]) {
            row[headerText] = item[fieldName].toUpperCase();
          } else if (fieldName === "hasMaterialRequest") {
            row[headerText] =
              item[fieldName] === true
                ? "Var"
                : item[fieldName] === false
                ? "Yok"
                : "-";
          } else {
            row[headerText] = item[fieldName] || "-";
          }
        });
        return row;
      });

      // Excel dosyasını oluştur
      const ws = xlsx.utils.json_to_sheet(excelData);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, "Teknik Takip");

      // Filtre bilgilerini ekle
      const filterInfo = [
        ["Teknik Takip Raporu - Filtreleme Bilgileri"],
        ["Oluşturma Tarihi:", new Date().toLocaleDateString("tr-TR")],
        ["Toplam Kayıt Sayısı:", dataList.length.toString()],
        [""],
      ];

      // Seçili filtreleri ekle
      if (seasonIds.value && seasonIds.value.length > 0)
        filterInfo.push(["Sezon:", "Filtrelenmiş"]);
      if (customers.value && customers.value.length > 0)
        filterInfo.push(["Müşteri:", "Filtrelenmiş"]);
      if (suppliers.value && suppliers.value.length > 0)
        filterInfo.push(["Tedarikçi:", "Filtrelenmiş"]);
      if (departmentIds.value && departmentIds.value.length > 0)
        filterInfo.push(["Departman:", "Filtrelenmiş"]);
      if (brandIds.value && brandIds.value.length > 0)
        filterInfo.push(["Marka:", "Filtrelenmiş"]);

      if (orderDateOne.value) {
        const dateInfo = [
          "Sipariş Tarihi:",
          new Date(orderDateOne.value).toLocaleDateString("tr-TR"),
        ];
        if (orderDateTwo.value) {
          dateInfo[1] += ` - ${new Date(orderDateTwo.value).toLocaleDateString(
            "tr-TR"
          )}`;
        }
        filterInfo.push(dateInfo);
      }

      if (hasMaterialRequest.value !== "all") {
        filterInfo.push([
          "Mal Giriş Talebi:",
          hasMaterialRequest.value === "true" ? "Var" : "Yok",
        ]);
      }

      // Filtreleme bilgilerini ekle
      const filterWs = xlsx.utils.aoa_to_sheet(filterInfo);
      xlsx.utils.book_append_sheet(wb, filterWs, "Filtre Bilgileri");

      // Excel dosyasını indir
      xlsx.writeFile(
        wb,
        `teknik_takip_raporu_${new Date().toISOString().slice(0, 10)}.xlsx`
      );

      // Yükleniyor göstergesini kapat
      loading.value = false;
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");

      // Başarı mesajı göster
      store.commit("SET_SUCCESS", "Excel dışa aktarma işlemi başarılı!");
    } catch (error) {
      console.error("Excel dışa aktarılırken hata oluştu:", error);

      // Yükleniyor göstergesini kapat
      loading.value = false;
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");

      // Hata mesajı göster
      store.commit(
        "SET_ERROR",
        "Excel dışa aktarma işlemi başarısız oldu. Lütfen daha sonra tekrar deneyin."
      );
    }
  });
};

// Yazdırma işlevi
const print = () => {
  const printWindow = window.open("", "_blank");
  if (!printWindow) {
    console.error("Yazdırma penceresi açılamadı.");
    return;
  }

  // CSS stilleri
  const styles = `
    <style>
      @page {
        size: landscape;
        margin: 10mm 10mm 10mm 10mm;
      }
      body { 
        font-family: Arial, sans-serif; 
        margin: 20px; 
        -webkit-print-color-adjust: exact; 
        print-color-adjust: exact;
      }
      h2 { 
        text-align: center; 
        margin-bottom: 20px;
        font-size: 16px;
        font-weight: bold;
      }
      table { 
        width: 100%; 
        border-collapse: collapse; 
        font-size: 9px; 
        margin-bottom: 20px;
      }
      th { 
        background-color: #f0f3f5; 
        font-weight: bold; 
        text-align: center;
        vertical-align: middle;
        padding: 5px 3px;
        border: 1px solid #999;
      }
      td { 
        border: 1px solid #999; 
        padding: 4px 3px;
        vertical-align: middle;
      }
      /* Sütunların hizalamaları */
      .text-center { text-align: center; }
      .text-left { text-align: left; }
      
      /* Tarih alanlarının hizalaması */
      td:nth-child(7), td:nth-child(8), td:nth-child(9), td:nth-child(10),
      td:nth-child(11), td:nth-child(12), td:nth-child(14), td:nth-child(15),
      td:nth-child(16), td:nth-child(17), td:nth-child(18), td:nth-child(19),
      td:nth-child(20), td:nth-child(21), td:nth-child(23) {
        text-align: center;
      }
      
      /* Kod ve metin alanlarının hizalaması */
      td:nth-child(1), td:nth-child(2), td:nth-child(3), td:nth-child(4),
      td:nth-child(5), td:nth-child(6), td:nth-child(13), td:nth-child(22) {
        text-align: left;
      }
      
      tr:nth-child(even) { background-color: #f8f9fa; }
      
      /* Footer ayarları */
      .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        font-size: 8px;
        text-align: center;
        padding: 5px 0;
        border-top: 1px solid #ddd;
      }
      
      .page-number:after {
        content: counter(page);
      }
      
      @media print {
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        table { page-break-inside: auto; }
        tr { page-break-inside: avoid; }
        thead { display: table-header-group; }
        tfoot { display: table-footer-group; }
      }
    </style>
  `;

  // HTML içeriği oluştur
  let content = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Teknik Takip Raporu</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
      ${styles}
    </head>
    <body>
      <h2>Teknik Takip Raporu</h2>
      <div style="font-size: 10px; margin-bottom: 15px;">
        <strong>Filtreler:</strong> 
        ${seasonIds.value && seasonIds.value.length > 0 ? "Sezon, " : ""}
        ${customers.value && customers.value.length > 0 ? "Müşteri, " : ""}
        ${suppliers.value && suppliers.value.length > 0 ? "Tedarikçi, " : ""}
        ${
          departmentIds.value && departmentIds.value.length > 0
            ? "Departman, "
            : ""
        }
        ${brandIds.value && brandIds.value.length > 0 ? "Marka, " : ""}
        ${
          orderDateOne.value
            ? `Sipariş Tarihi: ${new Date(
                orderDateOne.value
              ).toLocaleDateString("tr-TR")}`
            : ""
        }
        ${
          orderDateTwo.value
            ? ` - ${new Date(orderDateTwo.value).toLocaleDateString("tr-TR")}, `
            : ""
        }
        ${
          hasMaterialRequest.value !== "all"
            ? `Mal Giriş Talebi: ${
                hasMaterialRequest.value === "true" ? "Var" : "Yok"
              }`
            : ""
        }
      </div>
      <table>
        <thead>
          <tr>
            <th>Sezon</th>
            <th>Müşteri</th>
            <th>Marka</th>
            <th>Dept.</th>
            <th>Tedarikçi</th>
            <th>Model Kodu</th>
            <th>Artikel</th>
            <th>Yük.</th>
            <th>Var.</th>
            <th>ÖT G.</th>
            <th>ÖT Ç.</th>
            <th>FM KG.</th>
            <th>FM KÇ.</th>
            <th>NV Kod</th>
            <th>NV T.</th>
            <th>NV G.</th>
            <th>NV Ç.</th>
            <th>NV KG.</th>
            <th>NV KÇ.</th>
            <th>ÖT O.</th>
            <th>Ür. O.</th>
            <th>Kumaş O.</th>
            <th>MG T.</th>
            <th>Dos. T.</th>
          </tr>
        </thead>
        <tbody>
  `;

  // Filtrelenmiş veya tüm verileri kullan
  const dataList = filteredData.value || technicalTrackingReportList.value;

  // Veri satırlarını ekle
  dataList.forEach((item) => {
    content += `
      <tr>
        <td>${item.seasonName || "-"}</td>
        <td>${item.customerName || "-"}</td>
        <td>${item.brandName || "-"}</td>
        <td>${item.departmentName || "-"}</td>
        <td>${item.supplierName || "-"}</td>
        <td>${item.modelCode || "-"}</td>
        <td>${item.articleNo || "-"}</td>
        <td>${item.shippingDate || "-"}</td>
        <td>${item.deliveryDate || "-"}</td>
        <td>${item.otEntranceDate || "-"}</td>
        <td>${item.otExitDate || "-"}</td>
        <td>${item.fmCriticalEntranceDate || "-"}</td>
        <td>${item.fmCriticalExitDate || "-"}</td>
        <td>${
          item.nvRequestTradeCode ? item.nvRequestTradeCode.toUpperCase() : "-"
        }</td>
        <td>${item.nvRequestDate || "-"}</td>
        <td>${item.nvEntranceDate || "-"}</td>
        <td>${item.nvExitDate || "-"}</td>
        <td>${item.nvCriticalEntranceDate || "-"}</td>
        <td>${item.nvCriticalExitDate || "-"}</td>
        <td>${item.otApprovalDate || "-"}</td>
        <td>${item.productionApprovalDate || "-"}</td>
        <td>${item.fabricApprovalDate || "-"}</td>
        <td>${
          item.hasMaterialRequest === true
            ? "Var"
            : item.hasMaterialRequest === false
            ? "Yok"
            : "-"
        }</td>
        <td>${item.fileDeliveryDate || "-"}</td>
      </tr>
    `;
  });

  content += `
        </tbody>
      </table>
      <div class="footer">
        Yazdırma Tarihi: ${new Date().toLocaleDateString(
          "tr-TR"
        )} ${new Date().toLocaleTimeString(
    "tr-TR"
  )} | Sayfa: <span class="page-number"></span>
      </div>
    </body>
    </html>
  `;

  // İçeriği yazdırma penceresine yaz
  printWindow.document.write(content);
  printWindow.document.close();

  // Yazdırma penceresi yüklendikten sonra yazdırmayı başlat
  printWindow.onload = function () {
    setTimeout(() => {
      printWindow.print();
      // printWindow.close(); // İsteğe bağlı: Yazdırma tamamlandığında pencereyi otomatik kapat
    }, 500);
  };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Toast)),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _createVNode(_unref(Calendar), {
                  modelValue: orderDateOne.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((orderDateOne).value = $event)),
                  placeholder: "gg.aa.yyyy",
                  dateFormat: "dd.mm.yy",
                  showIcon: true,
                  class: "w-100"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", null, [
                _createVNode(_unref(Calendar), {
                  modelValue: orderDateTwo.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((orderDateTwo).value = $event)),
                  placeholder: "gg.aa.yyyy",
                  dateFormat: "dd.mm.yy",
                  showIcon: true,
                  class: "w-100"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", null, [
                _createVNode(SeasonMultiSelect, {
                  onChangeSeason: selectedSeason,
                  class: "w-100"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", null, [
                _createVNode(OrderTypeMultiSelect, {
                  onChangeOrderType: selectedOrderType,
                  class: "w-100"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", null, [
                _createVNode(CustomerMultiSelect, {
                  onChangeCustomer: selectedCustomer,
                  class: "w-100"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", null, [
                _createVNode(SupplierMultiSelect, {
                  onChangeSupplier: selectedSupplier,
                  class: "w-100"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", null, [
                _createVNode(DepartmentMultiSelect, {
                  onChangeDepartment: selectedDepartment,
                  class: "w-100"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", null, [
                _createVNode(BrandMultiSelect, {
                  onChangeBrand: selectedBrand,
                  class: "w-100"
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "hasMaterialRequest",
                    id: "materialRequestAll",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((hasMaterialRequest).value = $event)),
                    value: "all",
                    checked: ""
                  }, null, 512), [
                    [_vModelRadio, hasMaterialRequest.value]
                  ]),
                  _hoisted_28
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "hasMaterialRequest",
                    id: "materialRequestYes",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((hasMaterialRequest).value = $event)),
                    value: "true"
                  }, null, 512), [
                    [_vModelRadio, hasMaterialRequest.value]
                  ]),
                  _hoisted_30
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "radio",
                    name: "hasMaterialRequest",
                    id: "materialRequestNo",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((hasMaterialRequest).value = $event)),
                    value: "false"
                  }, null, 512), [
                    [_vModelRadio, hasMaterialRequest.value]
                  ]),
                  _hoisted_32
                ])
              ])
            ]),
            _hoisted_33,
            _createElementVNode("div", { class: "col-md-4 d-flex justify-content-end align-items-end" }, [
              _createElementVNode("button", {
                type: "reset",
                class: "btn btn-light me-3 px-6",
                onClick: clearFilters
              }, " Temizle "),
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary px-6",
                onClick: send
              }, " Ara ")
            ])
          ])
        ])
      ])
    ]),
    (_unref(hasData))
      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_unref(DataTable), {
                  value: _unref(technicalTrackingReportList),
                  filters: filters.value,
                  "onUpdate:filters": _cache[5] || (_cache[5] = ($event: any) => ((filters).value = $event)),
                  paginator: true,
                  rows: 100,
                  rowsPerPageOptions: [100, 250, 500],
                  filterDisplay: "menu",
                  responsiveLayout: "scroll",
                  loading: loading.value,
                  scrollable: true,
                  scrollHeight: "500px",
                  resizableColumns: true,
                  columnResizeMode: "fit",
                  onFilter: _cache[6] || (_cache[6] = ($event: any) => (filterData($event.filteredValue))),
                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                  globalFilterFields: [
              'customerName',
              'articleNo',
              'orderCode',
              'supplierName',
              'departmentName',
              'seasonName',
              'brandName',
              'otEntranceDate',
              'otExitDate',
              'fmCriticalEntranceDate',
              'fmCriticalExitDate',
              'nvRequestTradeCode',
              'nvRequestDate',
              'nvEntranceDate',
              'nvExitDate',
              'nvCriticalEntranceDate',
              'nvCriticalExitDate',
              'otApprovalDate',
              'productionApprovalDate',
              'hasMaterialRequest',
              'fileDeliveryDate',
            ],
                  currentPageReportTemplate: "Toplam {totalRecords} kayıttan {first} ile {last} arası gösteriliyor"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Column), {
                      field: "seasonName",
                      header: "Sezon",
                      sortable: "",
                      style: {"min-width":"6rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "customerName",
                      header: "Müşteri",
                      sortable: "",
                      style: {"min-width":"10rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "brandName",
                      header: "Marka",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "departmentName",
                      header: "Departman",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "supplierName",
                      header: "Tedarikçi",
                      sortable: "",
                      style: {"min-width":"8rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "modelCode",
                      header: "Model Kodu",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "articleNo",
                      header: "Artikel",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "shippingDate",
                      header: "Yükleme",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "deliveryDate",
                      header: "Varış",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "otEntranceDate",
                      header: "ÖT Geliş",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "otExitDate",
                      header: "ÖT Çıkış",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "fmCriticalEntranceDate",
                      header: "FM K. Geliş",
                      sortable: "",
                      style: {"min-width":"8rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "fmCriticalExitDate",
                      header: "FM K. Çıkış",
                      sortable: "",
                      style: {"min-width":"8rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "nvRequestTradeCode",
                      header: "NV Kodu",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.nvRequestTradeCode
                    ? data.nvRequestTradeCode.toUpperCase()
                    : "-"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "nvRequestDate",
                      header: "NV Talebi",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "nvEntranceDate",
                      header: "NV Geliş",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "nvExitDate",
                      header: "NV Çıkış",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "nvCriticalEntranceDate",
                      header: "NV K. Geliş",
                      sortable: "",
                      style: {"min-width":"8rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "nvCriticalExitDate",
                      header: "NV K. Çıkış",
                      sortable: "",
                      style: {"min-width":"8rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "otApprovalDate",
                      header: "ÖT Onayı",
                      sortable: "",
                      style: {"min-width":"7rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "productionApprovalDate",
                      header: "Üretim Onayı",
                      sortable: "",
                      style: {"min-width":"8rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "fabricApprovalDate",
                      header: "Kumaş Onayı",
                      sortable: "",
                      style: {"min-width":"8rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "hasMaterialRequest",
                      header: "M.G. Talebi",
                      sortable: "",
                      style: {"min-width":"8rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.hasMaterialRequest === true
                    ? "Var"
                    : data.hasMaterialRequest === false
                    ? "Yok"
                    : "-"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(Column), {
                      field: "fileDeliveryDate",
                      header: "Dosya Teslim",
                      sortable: "",
                      style: {"min-width":"8rem"},
                      showFilterMatchModes: false
                    }, {
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_unref(InputText), {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          type: "text",
                          class: "p-column-filter",
                          placeholder: "Ara",
                          onInput: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "filters", "loading"])
              ])
            ])
          ]),
          _createElementVNode("div", { class: "card-footer d-flex justify-content-start py-6 px-9" }, [
            _createElementVNode("button", {
              id: "technical-tracking-report_print",
              class: "btn btn-primary",
              onClick: print
            }, _hoisted_40),
            _createElementVNode("button", {
              id: "technical-tracking-report_excel",
              class: "btn btn-primary",
              style: {"margin-left":"5px"},
              onClick: exportExcel
            }, _hoisted_42)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})